import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';

export const MODULE_LIVE_CHAT = 'live-chat';
export const MODULE_AI_MARKETING = 'ai-marketing';

interface TenantModulesResponse {
  businessKey: string;
  modules: Record<string, boolean>;
}

@Injectable({ providedIn: 'root' })
export class ModulesService {
  private readonly http = inject(HttpClient);

  private readonly modulesSignal = signal<Readonly<Record<string, boolean>>>({});

  readonly modules = this.modulesSignal.asReadonly();

  async load(): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.http.get<TenantModulesResponse>(`${API_BASE_URL}/tenant/modules`)
      );
      this.modulesSignal.set(response.modules ?? {});
    } catch {
      this.modulesSignal.set({});
    }
  }

  isEnabled(moduleKey: string): boolean {
    return this.modulesSignal()[moduleKey] === true;
  }
}
